import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../../services/index';
import { loadScript, query } from '@/modules/util';
import { aegis, init } from '@/modules/aegis';
import ErrorBoundary from '@/components/ErrorBoundary';
import CrashTips from '@/components/CrashTips';

init();
function debug() {
  const src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
  return loadScript(src).then(() => {
    const vConsole = new window.VConsole();
    console.log('🚀 ~ file: index.tsx:16 ~ returnloadScript ~ vConsole:', vConsole);
    renderDom();
  });
}

function renderDom() {
  ReactDOM.render(
    <React.StrictMode>
      <ErrorBoundary
        app="react-catch"
        max={1}
        filters={[]}
        onCatch={(errors) => {
          console.log('🚀 ~ file: index.tsx:30 ~ errors:', errors);
          // 上报异常信息到后端，动态创建标签方式
          aegis.infoAll(`ErrorBoundary catch crash: ${JSON.stringify(errors)}`); // 崩溃日志
        }}
        errorRender={<CrashTips />}
      >
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
    document.getElementById('app'),
  );
}
if (query('debug') == '1') {
  debug();
} else {
  renderDom();
}

